import Layout from '@/layouts/index.vue';

export default [
  // {
  //   path: '/guarantee',
  //   name: 'Guarantee',
  //   component: Layout,
  //   redirect: '/guarantee/base',
  //   meta: {
  //     title: '投标保函',
  //     icon: 'file-safety',
  //     // single: true,
  //   },
  //   children: [
  //     {
  //       path: 'base',
  //       name: 'GuaranteeBase',
  //       component: () => import('@/pages/guarantee/index.vue'),
  //       meta: {
  //         title: '保函列表',
  //       },
  //     },
  //     {
  //       path: 'detail',
  //       name: 'GuaranteeDetail',
  //       component: () => import('@/pages/guarantee/components/detail.vue'),
  //       meta: {
  //         hidden: true,
  //         hiddenBreadcrumb: false,
  //         keepAlive: false,
  //         title: '保函详情',
  //       },
  //     },
  //     {
  //       path: 'invoiceBase',
  //       name: 'InvoiceBase',
  //       component: () => import('@/pages/invoice/base/index.vue'),
  //       meta: {
  //         title: '发票列表',
  //       },
  //     },
  //   ],
  // },
  {
    path: '/offlineGuarantee',
    name: 'OfflineGuarantee',
    component: Layout,
    redirect: '/offlineGuarantee/base',
    meta: {
      title: '保函管理',
      icon: 'file-safety',
      single: true,
    },
    children: [
      {
        path: 'base',
        name: 'OfflineGuaranteeBase',
        component: () => import('@/pages/offlineGuarantee/index.vue'),
        meta: {
          title: '保函列表',
        },
      },
      {
        path: 'apply',
        name: 'OfflineGuaranteeApply',
        component: () => import('@/pages/offlineGuarantee/apply.vue'),
        meta: {
          hidden: true,
          hiddenBreadcrumb: false,
          keepAlive: false,
          title: '保函申请',
        },
      },
    ],
  },
  // {
  //   path: '/invoice',
  //   name: 'Invoice',
  //   component: Layout,
  //   redirect: '/invoice/base',
  //   meta: {
  //     title: '发票管理',
  //     icon: 'bill',
  //   },
  //   children: [
  //     {
  //       path: 'title',
  //       name: 'InvoiceTitle',
  //       component: () => import('@/pages/invoice/title/index.vue'),
  //       meta: {
  //         title: '发票抬头',
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: '/enterprise',
  //   name: 'Enterprise',
  //   component: Layout,
  //   redirect: '/enterprise/base',
  //   meta: {
  //     title: '企业管理',
  //     icon: 'relativity',
  //   },
  //   children: [
  //     {
  //       path: 'base',
  //       name: 'EnterpriseBase',
  //       component: () => import('@/pages/enterprise/base/index.vue'),
  //       meta: {
  //         title: '企业信息',
  //       },
  //     },
  //     {
  //       path: 'members',
  //       name: 'EnterpriseMembers',
  //       component: () => import('@/pages/enterprise/members/index.vue'),
  //       meta: {
  //         title: '成员管理',
  //       },
  //     },
  //   ],
  // },
];
